var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Base_Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3985_201121",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3985_201121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "description",
    d: "M9 17.75H15C15.2125 17.75 15.3906 17.6781 15.5343 17.5343C15.6781 17.3904 15.75 17.2122 15.75 16.9998C15.75 16.7871 15.6781 16.609 15.5343 16.4655C15.3906 16.3218 15.2125 16.25 15 16.25H9C8.7875 16.25 8.60942 16.3219 8.46575 16.4658C8.32192 16.6096 8.25 16.7878 8.25 17.0003C8.25 17.2129 8.32192 17.391 8.46575 17.5345C8.60942 17.6782 8.7875 17.75 9 17.75ZM9 13.75H15C15.2125 13.75 15.3906 13.6781 15.5343 13.5343C15.6781 13.3904 15.75 13.2122 15.75 12.9998C15.75 12.7871 15.6781 12.609 15.5343 12.4655C15.3906 12.3218 15.2125 12.25 15 12.25H9C8.7875 12.25 8.60942 12.3219 8.46575 12.4658C8.32192 12.6096 8.25 12.7878 8.25 13.0003C8.25 13.2129 8.32192 13.391 8.46575 13.5345C8.60942 13.6782 8.7875 13.75 9 13.75ZM6.30775 21.5C5.80258 21.5 5.375 21.325 5.025 20.975C4.675 20.625 4.5 20.1974 4.5 19.6923V4.30775C4.5 3.80258 4.675 3.375 5.025 3.025C5.375 2.675 5.80258 2.5 6.30775 2.5H13.502C13.7458 2.5 13.9782 2.54683 14.1992 2.6405C14.4202 2.734 14.6128 2.86283 14.777 3.027L18.973 7.223C19.1372 7.38717 19.266 7.57975 19.3595 7.80075C19.4532 8.02175 19.5 8.25417 19.5 8.498V19.6923C19.5 20.1974 19.325 20.625 18.975 20.975C18.625 21.325 18.1974 21.5 17.6923 21.5H6.30775ZM13.5 7.6C13.5 7.855 13.5863 8.06875 13.7587 8.24125C13.9312 8.41375 14.145 8.5 14.4 8.5H18L13.5 4V7.6Z",
    fill: "#6852D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document_icon.aba043831a4cde0c96dd9114eb34de81.svg";
export { ForwardRef as ReactComponent };